import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/services/user.service';
import { saveAs } from 'file-saver';
import { BaseService } from 'src/app/core/services/base.service';
import { Config } from 'src/app/config/constants';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-office-admin-sales-report-details',
  templateUrl: './office-admin-sales-report-details.component.html',
  styleUrls: ['./office-admin-sales-report-details.component.scss']
})
export class OfficeAdminSalesReportDetailsComponent implements OnInit {

  leadType:any;
  commitionToOfLead:any;
  checkOVRInAgencyCode: any;
  reportType:any;
  statement_date:any;
  StatementDate = [];
  report_format:any;
  leadId:any;
  agentcodedata=[];
  agentID:any;
  ReportFormat = [
    {
      name: "Acrobat(PDF) file",
      type: 'pdf',
    },
    {
      name: "Excel",
      type: 'excel',
    }
  ];
  constructor(private router: Router,public user: UserService,private base: BaseService,private config:Config) { }

  ngOnInit(): void {
    this.leadId=sessionStorage.getItem('leadId');
    this.reportType=localStorage.getItem('report-type');
    this.leadType=sessionStorage.getItem('leadtype')
    this.commitionToOfLead=sessionStorage.getItem('commitionToOfLead')
    this.getLeadAgentsCodes();
    this.getCommissionStatementDates();
  }
  goToReportTab(){
    this.router.navigate(['/dashboard/OASale-report']);
  }
  getLeadAgentsCodes(){
    this.user.getLeadAgentsCodes(this.leadId).pipe()
    .subscribe(
      data => {
      this.agentcodedata=[];
      for(let i=0;i<data.data.agentCodes.length;i++){
        if (data.data.agentCodes[i].agentCode.toLowerCase().indexOf('ovr') > -1){
          this.agentcodedata.push(data.data.agentCodes[i])
        }
      }
      }, error => {
      }, () => { });
  }
  getCommissionStatementDates(){
    this.base.callGetServiceCall(this.config.getCommissionStatementDates).subscribe((data:any) =>{
      this.StatementDate=data.data;
    },error=>{{
    }},()=>{});
  }
  download(){
    if(this.reportType == 'MGA Commission'){
      this.mgaCommissiontoBrokerPdf();
    }
    if(this.reportType == 'MGA Sales by Broker'){
      if(this.leadType=='Office Admin Staff' && this.commitionToOfLead=='MGA'){
        this.mgaCommissionForOVR();
      }else{
        this.mgaOvrSalesbyBroker();
      }
    }
    if(this.reportType == 'MGA OVR Commission Statement'){
      this.mgaOvrcommission();
    }
  }
  mgaCommissiontoBrokerPdf(){
    var flag=true
    if(!this.agentID){flag=false}
    if(!this.report_format){flag=false}
    if(!this.statement_date){flag=false}
    if(flag==true){
    const request = {
      "agentId": this.agentID,
      "date": "",
      "fileType": this.report_format,
      "fromDate": "",
      "monthYear": "",
      "policyStatementId": 0,
      "statementLogId": this.statement_date,
      "toDate": "",
      "titleName": this.reportType
    }
    this.base.callPostService(this.config.v2MgaCommission, request).subscribe((data:any) =>{
      if(data.status==true){
        if(this.reportType == 'MGA Commission'){
          saveAs(data.data,"MGA Commission_"+this.statement_date); 
        }
      }
    },error=>{{
    }},()=>{});
    }else{
      Swal.fire('',"Please select all fields.",'error')
    }
  }
  mgaCommissionForOVR(){
    var flag=true
    if(!this.agentID){flag=false}
    if(!this.report_format){flag=false}
    if(!this.statement_date){flag=false}
    if(flag==true){
    const request = {

      "agentId": this.agentID,
      "date": "",
      "fileType": this.report_format,
      "fromDate": "",
      "mgaId": 0,
      "monthYear": "",
      "policyStatementId": 0,
      "runStatementId": 0,
      "statementLogId": this.statement_date,
      "toDate": "",
      "titleName": this.reportType
    }
    this.base.callPostService(this.config.mgaCommissionBrokerForOVR, request).subscribe((data:any) =>{
      if(data.status==true){
        saveAs(data.data,"MGA Sales by Broker_"+this.statement_date); 
      }
    },error=>{{
    }},()=>{});
    }else{
      Swal.fire('',"Please select all fields.",'error')
    }
  }
  mgaOvrSalesbyBroker(){
    var flag=true
    if(!this.agentID){flag=false}
    if(!this.report_format){flag=false}
    if(!this.statement_date){flag=false}
    if(flag==true){
    const request = {
      "agentId": this.agentID,
      "date": "",
      "fileType": this.report_format,
      "fromDate": "",
      "mgaId": 0,
      "monthYear": "",
      "policyStatementId": 0,
      "runStatementId": 0,
      "statementLogId": this.statement_date,
      "titleName": this.reportType,
      "toDate": ""
    }
    this.base.callPostService(this.config.mgaOvrSalesbyBroker, request).subscribe((data:any) =>{
      if(data.status==true){
        saveAs(data.data,"MGA Sales by Broker_"+this.statement_date); 
      }
    },error=>{{
    }},()=>{});
    }else{
      Swal.fire('',"Please select all fields.",'error')
    }
  }
  mgaOvrcommission(){
    var flag=true
    if(!this.agentID){flag=false}
    if(!this.report_format){flag=false}
    if(!this.statement_date){flag=false}
    if(flag==true){
    const request = {
      "agentId": this.agentID,
      "date": "",
      "fileType": this.report_format,
      "fromDate": "string",
      "mgaId": 0,
      "monthYear": "string",
      "policyStatementId": 0,
      "runStatementId": 0,
      "statementLogId": this.statement_date,
      "titleName": this.reportType,
      "toDate": ""
    }
    this.base.callPostService(this.config.mgaOvrcommission, request).subscribe((data:any) =>{
      if(data.status==true){
        saveAs(data.data,"MGA OVR Commission Statement_"+this.statement_date); 
      }
    },error=>{{
    }},()=>{});
    }else{
      Swal.fire('',"Please select all fields.",'error')
    }
  }
}
